import React, {useEffect, useRef, useState} from 'react';
import {Canvas} from '@react-three/fiber'
import AsinDance from './3d/AsinDance';
import {PerspectiveCamera, Stars} from '@react-three/drei';
import CameraDrift from "src/components/3d/CameraDrift";
import AppSyncEvents from "src/components/AppSyncEvents";
import {signInWithFederatedCredential} from '../appsync-federated-auth'
import {Slide, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {EmberText3D} from "src/components/3d/EmberText3D";
import DevModeButtons from "src/components/DevModeButtons";
import FloatingControls from 'src/components/FloatingControls';
import {Earth} from "src/components/3d/Earth";
import FreshStores from "src/components/3d/FreshStores";
import {StoreData} from "src/stores/storeLocations";
import useStore from "src/store";
import {signInWithLocalhostCredential} from "src/appsync-localhost-credential-auth";


function App() {

    const storeState = useStore((state) => state);

    const [isConfigured, setConfigured] = useState(false);
    const loginAttemptedRef = useRef(false);
    const [isDevMode, setDevMode] = useState(false);

    useEffect(() => {

        async function establishAppsyncConfig() {

            if (loginAttemptedRef.current) {
                return;
            }
            loginAttemptedRef.current = true;

            console.log("About to establish appsync config / login")

            try {
                await signInWithLocalhostCredential();
            } catch (e) {
                console.log("Failed to sign in with localhost credentials, using federated login flow", e)

                await signInWithFederatedCredential();
            }

            setConfigured(true);
        }

        void establishAppsyncConfig()
        window.addEventListener('keydown', (keyEvent) => {
            console.log(keyEvent.key);
            if (keyEvent.key === 'Escape') {
                setDevMode(true);
            }
            if (keyEvent.key === '1') {
                storeState.setShowFreshEvents(true);
                storeState.setShowWholeFoodsEvents(false);
            }
            if (keyEvent.key === '2') {
                storeState.setShowFreshEvents(false);
                storeState.setShowWholeFoodsEvents(true);
            }
            if (keyEvent.key === '3') {
                storeState.setShowFreshEvents(true);
                storeState.setShowWholeFoodsEvents(true);
            }
        });
    }, []);

    if (!isConfigured) {
        return <div>Signing in...</div>
    }

    return (
        <>
            <div>
                {isDevMode && (
                    <span>
            <FloatingControls />
            <DevModeButtons />
                        {/*Exit dev mode button*/}
                        <button onClick={() => {
                            setDevMode(false);
                        }}>Exit dev mode
              </button>
          </span>
                )}
            </div>
            <AppSyncEvents />
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                closeOnClick={false}
                transition={Slide}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

            <Canvas>
                <color attach="background" args={[0.01, 0.01, 0.06]} />
                {/*<Sky distance={2500} sunPosition={[-300, 20, 50]} />*/}
                <Stars radius={700} saturation={2} speed={1} factor={16} />
                <ambientLight intensity={.1} />
                <pointLight intensity={.7} position={[-500, 300, 900]} />
                <AsinDance />
                <EmberText3D scale={15} height={.1} position={[-135, 380, 150]}>
                    Grocery Management Tech
                </EmberText3D>
                <FreshStores
                    onStoreClick={(storeData: StoreData) => console.log("Clicked ", storeData)}
                    rotation={[0, Math.PI / 2, 0]}
                    scale={[4, 4, 4]}
                />
                <Earth scale={[4, 4, 4]} />
                <CameraDrift target={[0, 350, 0]} driftCenter={[0, 180, 600]} driftSpeed={0.2} driftScale={15} />
                <PerspectiveCamera makeDefault fov={40} />
            </Canvas>
        </>);
}

export default App;
